import "./About.css";
import iconImage from "../../images/logo.jpg";

export const About = () => {
  return (
    <section id="about" className="container container-about">
      <div className="about-left">
        <span className="purple-text">
          ✋Nicholas Kurniawan{" "}
          <span className="purple-smoke-text">- Introducciòn</span>{" "}
        </span>
        <p className="gray-text">
          Hello, my name is Nicholas, and I really enjoy developing the simple projects I create. 
  I like to collaborate with teams, 
  and I have more than 2 years of experience. This is my portfolio{" "}
        </p>
        <span className="white-text">
          <a href="">Portfolio</a>
        </span>
        <ul className="tech-stack">
          <li>Web Developer</li>
          <li>Ui/Ux Designer</li>
          <li>Backed Developer</li>
        </ul>
        <a className="about-see" href="#">Ver màs {"->"} </a>
      </div>
      <div className="about-right">
        <img src={iconImage} alt="" />
      </div>
    </section>
  );
};
